import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-platform-tag',
  templateUrl: './platform-tag.component.html',
  styleUrls: ['./platform-tag.component.scss'],
})
export class PlatformTagComponent {
  @Input() text = '';
}
